import { useState, useCallback } from 'react';
import type { Params } from './types';

const isSupporting = ({ withSlidesIndicator, swipeMode, slidesToShow, scrollType, showSwipeIndicator }): Params => {
    const basicSupport = withSlidesIndicator && (!swipeMode || showSwipeIndicator);
    const supportSingle = slidesToShow === 1 && scrollType === 'single';
    return basicSupport && supportSingle;
};

const useScrollCounter = ({ slidesToShow, scrollType, withSlidesIndicator, swipeMode, showSwipeIndicator }: Params) => {
    const [currentPosition, setCurrentPosition] = useState<number>(0);

    const supportSlidesIndicator = isSupporting({
        withSlidesIndicator,
        swipeMode,
        slidesToShow,
        scrollType,
        showSwipeIndicator,
    });

    const changeCounterPosition = useCallback(
        (newPosition: number) => setCurrentPosition(Math.max(newPosition, 0)),
        []
    );
    const resetCounterPosition = useCallback(() => setCurrentPosition(0), []);

    return {
        currentPosition,
        supportSlidesIndicator,
        changeCounterPosition,
        resetCounterPosition,
    };
};

export default useScrollCounter;
